import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable, lastValueFrom } from 'rxjs';
import { MUpdateOrderStatusRequest } from 'src/app/pages/user/user.module';
import { WsUserProfileService } from 'src/app/ws/wsUserProfile/ws-user-profile.service';
import { SharedPrefrences } from 'src/app/utils/utils.service';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent {
  @Input() id: any;
  @Input() deleteType: any;
  @Input() type?: any;
  @Output() saveClick = new EventEmitter();
  loaderShow: boolean = false;
  deleteItems!: Observable<any>;
  warehouse: any;
  mUpdateOrderStatusReq: MUpdateOrderStatusRequest = new MUpdateOrderStatusRequest()

  constructor(private wsUserProfileService: WsUserProfileService) {

  }

  /**
   * Common function to delete any module item
   */
  async deleteItem() {
    if (this.deleteType == "order") {
      this.mUpdateOrderStatusReq.id = this.id;
      this.mUpdateOrderStatusReq.modified_by = SharedPrefrences.getUserId();
      this.mUpdateOrderStatusReq.order_status = 'cancel'
      this.deleteItems = this.wsUserProfileService.updateOrderStatus(this.mUpdateOrderStatusReq) as Observable<any>;
    }
      await lastValueFrom(this.deleteItems).then(response => {
      if (response && response.statusCode == 200) {
        this.saveClick.emit({ delete: true });
      } else {
      }
    })
  }
}
